import React from "react";
import {ProjectsContext} from "./projects-context-props.ts";

const useProjectsContext = () => {
    const context = React.useContext(ProjectsContext);
    if(!context) {
        throw new Error('useProjectsContext must be used within a ProjectContextProvider');
    }
    return context;
};

export default useProjectsContext;